import React from 'react';
import HotelList from '../components/Hotel';

const VisitingInformation = () => {
  return (
    <div>
      <HotelList />
    </div>
  );
};

export default VisitingInformation;